import request from "@/utils/request"
// RTA资产规模及用户收益
export function getRtainfoData(type) {
    return request({
        method: 'get',
        url: '/actual/home/rtainfo/',
        params: type,
        headers: {
            token: localStorage.getItem('token')
        }

    })

}
// 实盘人数金额数
export function getCountAssetRatio(minutes) {
    return request({
        method: 'get',
        url: '/actual/home/scale/',
        params: minutes,
        headers: {
            token: localStorage.getItem('token')
        }

    })

}

// 实盘人数金额数历史数据
export function getScalelist(beginDate, endDate) {
    return request({
        method: 'get',
        url: '/actual/home/scalelist/',
        params: {
            beginDate,
            endDate,
        },
        headers: {
            token: localStorage.getItem('token')
        }
    })
}
//首页用户排行
export function getHomeRunking(queryType) {
    return request({
        method: 'get',
        url: '/actual/home/rank/?pageIndex=1&pageSize=10',
        params: queryType,
        headers: {
            token: localStorage.getItem('token')
        }
    })
}

//全部用户排行
export function getRunkingList(params) {
    return request({
        method: 'get',
        url: '/actual/home/rank/',
        params: params,
        headers: {
            token: localStorage.getItem('token')
        }

    })
}

//获取我的排名
export function getMyrank(params) {
    return request({
        method: 'post',
        url: 'actual/home/myrank/',
        data: params,
        headers: {
            token: localStorage.getItem('token')
        }
    })
}
//点阵图增加
export function addPoint(params) {
    return request({
        method: 'post',
        url: 'actual/point/add/',
        data: params,
        headers:{
            // "content-type": 'application/x-www-form-urlencoded',
            token:localStorage.getItem('token')
        }

    })

}

//获取点阵图信息
export function sendPointShow(params) {
    return request({
        method: 'post',
        url: 'actual/point/show/',
        data: {
            date:params
        },
        headers:{
        
            token:localStorage.getItem('token')
        }

    })

}






// WEBPACK FOOTER //
// ./src/api/Home.js